export const locale = {
    lang: 'tr',
    data: {
      'RESULTADOS': {
        'TITULO': 'RAPORLAMA',
        'DESCRIP': 'Bir seçenek seçin',
        'CARGANDO': 'Şirket anket sonuçları yükleniyor',
        'COMINGSOON': 'COVID Anketi sonuçları çok yakında ...',
        'VALIDANDO': {
          'BOTON': 'Doğrulama süreci',
          'MENSAJE': 'Bu ürünün sonuçları işleniyor, yakında size sunulacak',
        },
        'TABLAPRODUCTOS':{
          'COL1':'Yıl',
          'COL2':'Giriş',
          'BOT':'Biriş',
        },

        'SECCIONES': {
          'TITULO_VER':'Sürüm ',
          'NOSECCIONES': 'Kullanılabilir bölüm yok',

          'CERTIFICAR': {
            'TITULO': 'CERTIFY',
            'INFO': 'Danışmak istediğiniz yılı seçin',
            'BOTON': 'Giriş yap'
          },
          'MEDIR': {
            'TITULO': 'MEASUREMENT',
            'INFO': 'Danışmak istediğiniz yılı seçin',
            'BOTON': 'Giriş yap'
          },
          'PULSE': {
            'TITULO': 'PULSE CHECK',
            'INFO': 'Danışmak istediğiniz yılı seçin',
            'BOTON': 'Giriş yap'
          },
          'MEDIR_AMCO': {
            'TITULO': 'ICI',
            'INFO': 'Danışmak istediğiniz yılı seçin',
            'BOTON': 'Giriş yap'
          },
          'MEDIR_INNO': {
            'TITULO': 'Innmotion survey',
            'INFO': 'Danışmak istediğiniz yılı seçin',
            'BOTON': 'Giriş yap'
          },
          'CertiAdicio': {
            'TITULO': 'EK SERTİFİKALAR',
            'INFO': 'Danışmak istediğiniz yılı seçin',
            'BOTON': 'Giriş yap'
          },
          'Amco': {
            'TITULO': 'AMCO',
            'INFO': 'Danışmak istediğiniz yılı seçin',
            'BOTON': 'Giriş yap'
          },
          'TrabDign': {
            'TITULO': 'ÖNEMLİ ÇALIŞMA',
            'INFO': 'Danışmak istediğiniz yılı seçin',
            'BOTON': 'Giriş yap'
          },
          'PrimEmp': {
            'TITULO': 'İLK İŞ',
            'INFO': 'Danışmak istediğiniz yılı seçin',
            'BOTON': 'Giriş yap'
          },
          'GOFLOW': {
            'TITULO': 'Sonuçlar GoFlow',
            'INFO': 'Danışmak istediğiniz yılı seçin',
            'BOTON': 'Giriş yap'
          },
        },

        'TABPRIN':{
          'TABPRO':'Sertifikasyon süreci',
          'TAB4ALL': 'FORALL sonuçları',
          'TAB4ALL2': 'İşlem sonuçları',
          'TITURES': 'FORALL sonuçları',
          'TABCER':'Ölçücü süreçler',
          'TABPULSE':'Nabız kontrol süreçleri',
          'TABICI': 'ICI sonuçları',
          'TABINNO': 'Innmotion survey sonuçları',
          'TABAMCO': 'AMCO süreçleri',
          'TABTRABDIG': 'İnsana Yakışır İş Süreçleri',
          'TABPRIEMP': 'İlk istihdam süreçleri',
        },
        'TABPRIN5':{
          'TABPRO':'Global sürüm 3.1 süreci',
          'TAB4ALL':'Resultados FORALL',
          'TAB4ALL2':'Proceso de FORALL',
          'TITURES':'Resultados FORALL',
          'TABCER':'Leader sürüm 3.2',
          'TABPULSE':'Covid sürüm 3.3 süreci',
        },
        '4ALLVIEJAS':{
         'TITULO': 'FORALL devralınan sonuçlar',
         'BOTON': 'Başlamak',
         'SIN_4ALL_HEREDADAS':"FORALL sonuçlarını kiralamadınız",
         'TITULOCERTIFICAR':'Onayla',
         'APLICACIONANIO':'Başvuru yılı: 2019',
        },
        '4ALL':{
            'CARGANDO':'FORALL sonuçları yükleniyor',
             'TITULO4ALL': 'UYGULAMA SONUÇLARI',
             'TABPRACTICAS':{
              'TITULOTAB': 'Uygulamalar 4all',
              'TITULOPRACGLOBAL':{
              'SUBTITULOPRAC': 'FORALL uygulamalarının küresel sonucu',
              'TEXTO1':'Yüzdesi ',
              'TEXTO2': 'FORALL uygulamaları bilgisi',
              'TEXTO3': 'kuruluşunuzda',
              'TEXTO4': 'Seviyesi',
              'TEXTO5': 'tanıdıkları ortak çalışanların memnuniyeti',
              'TEXTO6': 'FORALL uygulamaları',
            },
            'TITULOPRAC4All':{
              'TITULOTAB': 'Demografik',
              'SUBTITULO4ALL': 'FORALL uygulamalarına göre sonuçlar',
              'TITULOCONO': 'BILGI',
              'TEXTO1': 'Kuruluşunuzdaki FORALL uygulamalarının bilgi yüzdesi',
              'TITULOSATIS': 'MEMNUNIYEY',
              'TEXTO2': 'FORALL uygulamasını bilen çalışanların memnuniyet düzeyi',
            }
          },

        'DEMOGRAFICOS':{
          'Cargo homologado ': 'Onaylanmış pozisyon',
          'Años de Trabajo': 'Antik',
            'Condición de trabajo': 'Çalışma şartı',
            'Tipo de trabajo': 'Tazminat şeması',
            'Género': 'Cinsiyet',
            'Educación': 'Akademik derece',
            'PORCONOTXT1': 'Percentage of',
            'PORCONOTXT2': 'FORALL uygulamaları bilgisi',
            'PORCONOTXT3': "demografik cu'ya göret",
            'PORSATITXT1': 'Seviyesi',
            'PORSATITXT2': 'FORALL uygulamalarını bilen çalışanların memnuniyeti',
            'PORSATITXT3': 'demografiye göre',
         },
         'MODL_N_RESU':'Şu anda sonuç yok',
         'MODL_N_RESU_4ALL':'İstenen sonuçlar görüntülenemiyor',
         },
         "ETIQ_MODAL_RESULT":{
           "TITLE_MODA":"Sonuç platformAnahtarı bulunamadı",
         "ETQ_PROD": "Ürün: ",
         "ETQ_BROK": "Aracı: ",
         "ETQ_COUN": "Ülke: ",
         "ETQ_LANG": "Dil: ",
         "ETQ_CERTY": "Sertifika: ",
         "true": "Etkin",
         "false": "Devre dışı",
         "COUNTR_NO_SELEC":"*Seçili değil*",
         }
      },
      'RESULTADOS_5':{
        'TITULO': 'Sonuçlar 5.0',
        'SECCIONES': {
          'NOSECCIONES': 'Uygun değil',
          '31': {
            'TITULO': 'genel sürüm 3.1',
            'INFO': 'Danışmak istediğiniz yılı seçin',
            'BOTON': 'Git'
          },
          '32': {
            'TITULO': 'Leader sürüm 3.2',
            'INFO': 'Danışmak istediğiniz yılı seçin',
            'BOTON': 'Git'
          },
          '33': {
            'TITULO': 'Covid sürüm 3.3',
            'INFO': 'Danışmak istediğiniz yılı seçinl',
            'BOTON': 'Git'
          }
        },
      },
      'CONFING_RESUL':{
      'TITULO_MODAL':'BenchMarks sonuçları yapılandırması',
      'TAB_DEMO_EXCEL':'Excel demografisi',
      'SUB_TIT_TAB_DEMO_EXCEL':'Demografik bilgileri seçin:',
      'TAB_DEMO_ENCU':'Demografi anketi',
      'SUB_TIT_TAB_DEMO_ENCU':'Demografik bilgileri seçin:',
      'TAB_BENCHMA':'Kıyaslama',
      'SUB_TIT_TAB_BENCHMA':'',
      'TITULO_MAT_EXPAN_TAMANO':'Tepe',
      'TITULO_MAT_EXPAN_SECTOR':'sektörel',
      'TITULO_MAT_EXPAN_REGIONAL':'Aralıklar',
      'OKSELECT':'Seçildi',
      'NOTSELECT':'Seçili değil',
      'TAB_NIV_GEOG':'Coğrafi seviyeler',
      'SUB_TIT_TAB_NIV_GEOG':'Coğrafi seviyeleri seçin:',
      'TAB_NIV_ESTRUC':'Yapısal seviyeler',
      'SUB_TIT_TAB_NIV_ESTRUC':'Yapısal seviyeleri seçin:',
      'BTN_ACEPTAR':'Kabul etmek',
      'MODAL_CARGA_DEMO_EXC':'Demografik bilgiler yükleniyor',
      'MODAL_CARGA_DEMO_ENC':'Anket demografisi yükleniyor',
      'MODAL_CARGA_BENCH':'Karşılaştırma Yükleniyor',
      'MODAL_CARGA_NIV_GEO':'Coğrafi seviyeler yükleniyor',
      'MODAL_CARGA_NIV_ESTR':'Yapısal seviyeleri yükleme',
      'TAB_BENCH_MARK':'Kalite Testi',
      'MODAL_CARGA_BENCH_MARK':'Karşılaştırma yükleniyor',
      'SUB_TIT_TAB_BENCH_MARK':'Karşılaştırma Seçin',
      'SUCCES_GUAR_SELEC':'Değişiklikler doğru şekilde kaydedildi',
      'CONFI_GUAR_SELE': 'Yapılan değişiklikleri kaydettiğinizden emin misiniz?',
       'RES_SI': 'Evet',
       'RES_NO': 'Hayır',
       'MAT_TOOL_BTN_CONFI_RESULT':'Sonuç yapılandırması',
       'MODAL_GUA_INFOR':'Bilgileri Kaydetme',
       'SUB_TIT_TAB_HIERARCHI':'HiyerarşikYol seçimi:',
       'MODAL_CARGA_HIERARCHI':'Hiyerarşik Yollar Yükleniyor',
       'SIN__HIERARCHI_MOSTRAR':'Şu anda hiyerarşikYollarda sonuç yok',
       'EXTERNAL_PORTAL':'Harici 4all ın URL sini kopyalayın',
       'INTRU_TEX_BENCHMARK':'*Kıyaslamaları taşı',
       'BENCHMARCK_SELEC':'Sunum sırasına göre seçilen BenchMark:',
       'BTN_SAV_BENCH':'BenchMark ı kaydet',
       'TEX_SEARC_BENCH_TOP':'Aramak için en iyi kıyaslamayı girin',
       'TEX_SEARC_BENCH_SECT':'Aramak için sektör karşılaştırmasını girin',
       'TEX_SEARC_BENCH_RANG':'Aramak için kıyaslama aralığını girin',
       'INFO_MAS_BENCH_ESPA':'gruplandırılmış kıyaslama',
       'BTN_ADD_BENCH_SUGE':'önerilen ekle',
       'MOD_WARN_MAX_PERMIT':'İzin verilen boşluk sayısını aştığı için eklemek mümkün değil',
       'MOD_WARN_UN_CATE':'Şu anda seçilen kategorinin bir kıyaslaması zaten var',
       'MOD_WARN_NO_APLIC':'BenchMarkı seçmeme seçeneği etkin olduğu için eklenmesi mümkün değildir.',
       'INSTRU_DRAP&DROP_1':'BenchMarkı buraya Sürükle&Bırak',
       'LABE_CIRC_PROGRE':'kriterler',
       'LABE_INSTRU_SELECT_BENCH':'¿BenchMarkı seçmek istiyor musunuz?',
     },
     'CONFING_RESUL_GOFLOW':{
     'TITULO_MODAL':'GoFlow Sonuç Bilgileri',
       },
     'CONFING_RESUL_EMP':{
       'TITULO_MODAL':'Ham Veri Emprising',
         'INT_TEX':'Talimat: Lütfen içe aktarılacak Ham Veri dosyasını yükleyin',
         'TOOLT_CHA_INF':'Dosyayı seçtim',
         'UPLO_INF':'Satır verileri içe aktarılıyor',
         'SUCC_UPLO_INF':'Başarıyla içe aktarıldı',
     }
    }
};
